import React from 'react';
import { CheckCircleIcon, CircleIcon, ClockIcon, ChevronRightIcon } from 'lucide-react';
export const ActionItem = ({
  action
}) => {
  const getStatusIcon = status => {
    switch (status) {
      case 'completed':
        return <CheckCircleIcon size={18} className="text-green-500" data-id="element-44" />;
      case 'in-progress':
        return <ClockIcon size={18} className="text-blue-500" data-id="element-45" />;
      case 'not-started':
      default:
        return <CircleIcon size={18} className="text-gray-300" data-id="element-46" />;
    }
  };
  const getStatusText = status => {
    switch (status) {
      case 'completed':
        return 'Completed';
      case 'in-progress':
        return 'In Progress';
      case 'not-started':
        return 'Not Started';
      default:
        return status;
    }
  };
  const getTeamColor = team => {
    switch (team) {
      case 'CX':
        return 'bg-blue-100 text-blue-600';
      case 'Research':
        return 'bg-purple-100 text-purple-600';
      case 'Marketing':
        return 'bg-pink-100 text-pink-600';
      case 'Product':
        return 'bg-green-100 text-green-600';
      default:
        return 'bg-gray-100 text-gray-600';
    }
  };
  const getPriorityColor = priority => {
    switch (priority) {
      case 'high':
        return 'bg-red-100 text-red-600';
      case 'medium':
        return 'bg-yellow-100 text-yellow-600';
      case 'low':
        return 'bg-green-100 text-green-600';
      default:
        return 'bg-gray-100 text-gray-600';
    }
  };
  return <div className="p-4 border-b border-gray-200 hover:bg-gray-50 transition-colors flex items-center" data-id="element-47">
      <div className="mr-3" data-id="element-48">{getStatusIcon(action.status)}</div>
      <div className="flex-1" data-id="element-49">
        <h4 className="font-medium text-gray-800" data-id="element-50">{action.title}</h4>
        <div className="flex items-center gap-3 mt-1 text-sm" data-id="element-51">
          <span className="text-gray-500" data-id="element-52">Assigned to: {action.assignee}</span>
          <span className={`px-2 py-0.5 rounded-full text-xs ${getTeamColor(action.team)}`} data-id="element-53">
            {action.team}
          </span>
        </div>
      </div>
      <div className="flex items-center gap-4" data-id="element-54">
        <div className="text-sm text-gray-500 flex items-center gap-1" data-id="element-55">
          <span data-id="element-56">Due: {action.dueDate}</span>
        </div>
        <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${getPriorityColor(action.priority)}`} data-id="element-57">
          {action.priority.charAt(0).toUpperCase() + action.priority.slice(1)}
        </span>
        <span className="text-xs font-medium px-2 py-0.5 rounded-full bg-gray-100 text-gray-600" data-id="element-58">
          {getStatusText(action.status)}
        </span>
        <button className="text-gray-400 hover:text-gray-600" data-id="element-59">
          <ChevronRightIcon size={18} data-id="element-60" />
        </button>
      </div>
    </div>;
};